import { render, staticRenderFns } from "./text-translations.vue?vue&type=template&id=3ecfb6b2&scoped=true&"
import script from "./text-translations.ts?vue&type=script&lang=ts&"
export * from "./text-translations.ts?vue&type=script&lang=ts&"
import style0 from "./text-translations.scss?vue&type=style&index=0&id=3ecfb6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecfb6b2",
  null
  
)

export default component.exports